export default {
  src: 'https://dummyimage.com/640x480/000/fff',
  alt: 'Dummy Image',
  layout: [{ size: 0, bound: 361 }],
  component: 'a-image-v2',
}
